const {Component} = require("react");
const hammer = require("app/util/hammer");

class Trigger extends Component {

	close() {

		let classList = document.body.className.split(" ");
		let index = classList.indexOf("show-search");

		if (index === -1) {
			return;
		}

		classList.splice(index, 1);
		document.body.className = classList.join(" ");
	}

	_onClick = (e) => {
		e.preventDefault();
		this.close();
	};

	componentDidMount() {
		const searchBar = document.querySelector(".desktop-search");
		const handleClickAway = e => {
			if (searchBar.contains(e.target)) {
				return;
			}

			this.close();
		};

		if (searchBar) {
			// Click outside
			document.body.addEventListener("click", e => handleClickAway(e));
			hammer(document.body).on("tap", e => handleClickAway(e));

		}
	}

	render() {
		return (
			<div className="close-search" onClick={this._onClick}>
              <div className="line-1"></div>
              <div className="line-2"></div>
            </div>
		);
	}
}

module.exports = Trigger;
